import { useState } from 'react';
import './Contato.css';
import { IconeAlerta, IconeCheck, IconeInstagram, IconeWhatsApp } from '../Icones/Icones';
import { INSTAGRAM_URL, WEB3FORMS_ACCESS_KEY, WHATSAPP_EXIBICAO, linkWhatsApp } from '../../config';

const INTERESSES = ['Torque', 'Gerenciador de Transportes', 'Outro projeto sob demanda'];

const chaveConfigurada = WEB3FORMS_ACCESS_KEY && !WEB3FORMS_ACCESS_KEY.startsWith('COLE_AQUI');

function Contato() {
    // ocioso | enviando | sucesso | erro
    const [estado, setEstado] = useState('ocioso');

    async function enviar(evento) {
        evento.preventDefault();
        const formulario = evento.currentTarget;
        const dados = Object.fromEntries(new FormData(formulario));

        // Campo invisível: só robôs preenchem.
        if (dados.botcheck) return;

        if (!chaveConfigurada) {
            console.warn('Web3Forms: defina WEB3FORMS_ACCESS_KEY em src/config.js.');
            setEstado('erro');
            return;
        }

        setEstado('enviando');
        try {
            const resposta = await fetch('https://api.web3forms.com/submit', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                    access_key: WEB3FORMS_ACCESS_KEY,
                    subject: `Novo contato pelo site: ${dados.interesse}`,
                    from_name: 'Site C1010',
                    ...dados,
                }),
            });
            const resultado = await resposta.json();
            if (!resposta.ok || !resultado.success) throw new Error(resultado.message);

            formulario.reset();
            setEstado('sucesso');
        } catch (erro) {
            console.error('Falha ao enviar o formulário:', erro);
            setEstado('erro');
        }
    }

    return (
        <section id="contato" className="secao contato">
            <div className="container contato-grade">
                <div className="contato-texto revelar">
                    <span className="rotulo rotulo-claro">Contato</span>
                    <h2 className="titulo-secao">Vamos conversar?</h2>
                    <p className="contato-descricao">
                        Conta um pouco sobre você e a gente responde rapidinho, por WhatsApp ou e-mail.
                    </p>

                    <div className="contato-canais">
                        <a href={linkWhatsApp('Olá! Vim pelo site da C1010.')} target="_blank" rel="noopener noreferrer">
                            <span className="canal-icone"><IconeWhatsApp tamanho={20} /></span>
                            <span>
                                <small>WhatsApp</small>
                                {WHATSAPP_EXIBICAO}
                            </span>
                        </a>
                        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
                            <span className="canal-icone"><IconeInstagram tamanho={20} /></span>
                            <span>
                                <small>Instagram</small>
                                @c1010sistemas
                            </span>
                        </a>
                    </div>
                </div>

                <div className="contato-cartao revelar" style={{ '--atraso': '0.12s' }}>
                    {estado === 'sucesso' ? (
                        <div className="contato-sucesso" role="status">
                            <span className="sucesso-icone"><IconeCheck tamanho={28} /></span>
                            <h3>Recebemos!</h3>
                            <p>Em breve a gente entra em contato.</p>
                            <button type="button" className="btn btn-primario" onClick={() => setEstado('ocioso')}>
                                Enviar outra mensagem
                            </button>
                        </div>
                    ) : (
                        <form className="formulario" onSubmit={enviar}>
                            <div className="campo">
                                <label htmlFor="nome">Nome</label>
                                <input id="nome" name="nome" type="text" autoComplete="name" required />
                            </div>
                            <div className="campo">
                                <label htmlFor="empresa">Empresa</label>
                                <input id="empresa" name="empresa" type="text" autoComplete="organization" required />
                            </div>
                            <div className="campo">
                                <label htmlFor="contato">WhatsApp ou e-mail</label>
                                <input id="contato" name="contato" type="text" required />
                            </div>
                            <div className="campo">
                                <label htmlFor="interesse">Tenho interesse em</label>
                                <select id="interesse" name="interesse" required defaultValue="">
                                    <option value="" disabled>Selecione</option>
                                    {INTERESSES.map((opcao) => (
                                        <option key={opcao} value={opcao}>{opcao}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="campo campo-largo">
                                <label htmlFor="mensagem">
                                    Mensagem <span className="opcional">(opcional)</span>
                                </label>
                                <textarea id="mensagem" name="mensagem" rows="4" />
                            </div>

                            <input type="checkbox" name="botcheck" className="visualmente-oculto" tabIndex="-1" autoComplete="off" aria-hidden="true" />

                            {estado === 'erro' && (
                                <div className="contato-erro campo-largo" role="alert">
                                    <IconeAlerta tamanho={20} />
                                    <p>
                                        Não conseguimos enviar. Tente pelo WhatsApp:{' '}
                                        <a href={linkWhatsApp('Olá! Vim pelo site da C1010.')} target="_blank" rel="noopener noreferrer">
                                            {WHATSAPP_EXIBICAO}
                                        </a>
                                    </p>
                                </div>
                            )}

                            <button type="submit" className="btn btn-primario campo-largo" disabled={estado === 'enviando'}>
                                {estado === 'enviando' ? 'Enviando…' : 'Enviar mensagem'}
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </section>
    );
}

export default Contato;
